import React from "react";

export const ProvideFeedbackIcon: React.FC<React.SVGProps<SVGSVGElement>> = (
  props,
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="12"
    height="12"
    viewBox="0 0 12 12"
    fill="none"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M1.10899 2.54601C1 2.75992 1 3.03995 1 3.6V3.9C1 4.46005 1 4.74008 1.10899 4.95399C1.20487 5.14215 1.35785 5.29513 1.54601 5.39101C1.75992 5.5 2.03995 5.5 2.6 5.5H9.4C9.96005 5.5 10.2401 5.5 10.454 5.39101C10.6422 5.29513 10.7951 5.14215 10.891 4.95399C11 4.74008 11 4.46005 11 3.9V3.6C11 3.03995 11 2.75992 10.891 2.54601C10.7951 2.35785 10.6422 2.20487 10.454 2.10899C10.2401 2 9.96005 2 9.4 2H2.6C2.03995 2 1.75992 2 1.54601 2.10899C1.35785 2.20487 1.20487 2.35785 1.10899 2.54601ZM3.25 3.25H2.25V4.25H3.25V3.25Z"
      fill="#4C4CF6"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M1.10899 7.04601C1 7.25992 1 7.53995 1 8.1V8.4C1 8.96005 1 9.24008 1.10899 9.45399C1.20487 9.64215 1.35785 9.79513 1.54601 9.89101C1.75992 10 2.03995 10 2.6 10H9.4C9.96005 10 10.2401 10 10.454 9.89101C10.6422 9.79513 10.7951 9.64215 10.891 9.45399C11 9.24008 11 8.96005 11 8.4V8.1C11 7.53995 11 7.25992 10.891 7.04601C10.7951 6.85785 10.6422 6.70487 10.454 6.60899C10.2401 6.5 9.96005 6.5 9.4 6.5H2.6C2.03995 6.5 1.75992 6.5 1.54601 6.60899C1.35785 6.70487 1.20487 6.85785 1.10899 7.04601ZM3.25 7.75H2.25V8.75H3.25V7.75Z"
      fill="#4C4CF6"
    />
  </svg>
);
